import {http} from '@/utils/http'
import {IFilter} from "@/types/main";
import {cleanParams} from "@/utils/cleanParams";

export const messageService = {
    getMessages(filter: IFilter) {
        return http.get('/activity', {
            params: cleanParams(filter)
        })
    },
}